export const routes = {
  domainSearch: "search.do",
  addExtras: "extras.do",
  // cart: "cart.do", // TODO: It's not implemented yet
  customerDetails: "customer.do",
  payment: "payment.do",
  vps: "vps.do",
  confirmation: "confirmation.do",
};

export function getValidPageByUrl(pageName) {
  for (let page in routes) {
    if (pageName === routes[page]) {
      return page;
    }
  }
  return null;
}

export function buildUrlFrom({ pageName, searchParams, hash = "" }) {
  searchParams = searchParams.size === 0 ? searchParams : `&${searchParams}`;

  if (!pageName) return false;
  return `?page=${routes[pageName]}${searchParams}${hash}`;
}
